export const YGFL = "ygfl"
export const FYZS = "fyzs"
export const FYSX = "fysx"